import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { EDealType } from 'shared/repositories/cpd/entities/v1_create_cpd_draft/PublicV1CreateCpdDraftRequest';
import { fetchCreateCpdDraft, TCreateCpdDraftResponse } from 'shared/repositories/cpd/v1/create-cpd-draft';
import { selectIsOfferOwnedByUser, selectOfferId } from 'shared/selectors';
import { selectCpdSource } from 'shared/selectors/cpd/cpd';
import { IThunkActionCreator } from 'shared/store';

import { setCpdDraftId, setCpdDraftStatus } from './';
import { ECpdDraftStatus } from '../../types/cpd/cpd';

interface IParams {
  phone: string | null;
  legalAgreementAccepted?: boolean;
}

export const createDraftCpd =
  ({ phone, legalAgreementAccepted }: IParams): IThunkActionCreator<Promise<void>> =>
  async (dispatch, getState, context) => {
    try {
      const state = getState();
      const offerId = selectOfferId(state);

      const source = selectCpdSource(state) as string;
      const isHomeowner = selectIsOfferOwnedByUser(state);
      const dealType = isHomeowner ? EDealType.Sale : EDealType.Buy;

      const resCpdDraft = (await fetchCreateCpdDraft({
        httpApi: context.httpApi,
        parameters: {
          offerId,
          phone,
          source,
          dealType,
          legalAgreementAccepted,
        },
      })) as TCreateCpdDraftResponse;

      dispatch(setCpdDraftStatus(ECpdDraftStatus.loading));

      if (resCpdDraft.statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          statusCode: resCpdDraft.statusCode,
          domain: 'createDraftCpd.ts',
          message: resCpdDraft.response.message as string,
        });
      }

      const { cpdDraftId } = resCpdDraft.response;

      dispatch(setCpdDraftId(cpdDraftId));
      dispatch(setCpdDraftStatus(ECpdDraftStatus.success));
    } catch (e) {
      context.logger.error(e);

      dispatch(setCpdDraftStatus(ECpdDraftStatus.fail));
    }
  };
